import React from 'react'

class SmulkintuvaiComponent extends React.Component {
    render() {
        return <div  id="content">
        <div  id="dsc">
          <h1 >Smulkintuvai</h1>
          <p >
            </p><div>Plastiko  15; 37; 55 Kw</div>
              <iframe  allowfullscreen="" frameborder="0" height="315" width="420" src="https://www.youtube.com/embed/Jw2J4dXLnPw"></iframe>
              
          
          <p >
            </p><div>Polistirolo  11 Kw</div>
            <iframe  allowfullscreen="" frameborder="0" height="315" width="420" src="https://www.youtube.com/embed/eETZ5UTFqLk"></iframe>
          
          <p >
            </p><div >Šiaudų  11; 15; 18,5; 22 Kw</div>
      
            <iframe  allowfullscreen="" frameborder="0" height="315" width="420" src="https://www.youtube.com/embed/9syQ8sBRx34"></iframe>
          
        </div>
      </div>
    }
}

export default SmulkintuvaiComponent